import { BridgeErrorCodeValue } from '@tencent/tvf-jsapi/lib/umd/src/helper';
import { Base } from '../channel/base';

/**
 * 各个 Api 实现接口
 */
export interface ApiInterface extends Base {
  needRefresh: boolean; // 是否需要续期，外部可以根据此属性进行事件监听并在续期后处理逻辑
  refreshed: boolean; // 如果需要续期的话，记录续期动作是否完成，无论是否成功
  ifRefreshSuccess: boolean; // 如果需要续期的话，续期是否成功
  isHidePhoneLogin?: boolean; // 是否隐藏手机登录
  login(options?: Record<string, any>): Promise<ReqSucResult<boolean> | ReqErrResult<null>>;
  logout(needReload?: boolean, options?: Record<string, any>): Promise<ReqSucResult<boolean> | ReqErrResult<null>>;
  isLogin(options?: Record<string, any>): Promise<ReqSucResult<boolean> | ReqErrResult<null>>;
  getLoginInfo(options?: Record<string, any>): Promise<ReqSucResult<LoginInfo> | ReqErrResult<null>>;
  getUserInfo(options?: Record<string, any>): Promise<ReqSucResult<UserInfo> | ReqErrResult<null>>;
}

/**
 * 返回结构
 */
export interface ReqSucResult<T> {
  errCode: 0;
  errMsg: string;
  result: T;
}
export interface ReqErrResult<T> {
  errCode: -1 | BridgeErrorCodeValue;
  errMsg: string;
  result: T;
}

/**
 * 端外登录渠道类型，根据域名区分，一个页面固定走某一种类型的登录
 */
export enum ChannelType {
  /** 腾讯视频 */
  TENVIDEO = 'TENVIDEO',
  /** 微视 */
  WEISHI = 'WEISHI',
  /** 腾讯体育 */
  SPORTS = 'SPORTS',
  /** 应用宝 */
  YYB = 'YYB',
  /** 腾讯动漫 */
  AC = 'AC',
  /** 未知 */
  UNKNOWN = 'UNKNOWN',
}

/**
 * 页面打开平台（端内App）
 */
export enum PlatformType {
  /** 微信 */
  WX = 'WX',
  /** QQ */
  QQ = 'QQ',
  /** QQ 浏览器 */
  QQ_BROWSER = 'QQ_BROWSER',
  /** 腾讯视频 */
  TENVIDEO = 'TENVIDEO',
  /** 微视 */
  WEISHI = 'WEISHI',
  /** 腾讯体育 */
  SPORTS = 'SPORTS',
  /** 应用宝 */
  YYB = 'YYB',
  /** BBG */
  BBG = 'BBG',
  /** 腾讯动漫 */
  AC = 'AC',
  /** 微信小程序 */
  WX_MINI_PROGRAM = 'WX_MINI_PROGRAM',
  /** 未知 */
  UNKNOWN = 'UNKNOWN',
}

export enum LoginType {
  // NO_LOGIN = 'NO_LOGIN',
  // QQ = 'QQ',
  // WX = 'WX',
  nologin = 'nologin',
  qq = 'qq',
  wx = 'wx',
  phone = 'phone'
}

export interface LoginInfo {
  type: LoginType;

  // qq & wx
  appid?: string;
  openid?: string;
  accessToken?: string;
  refreshToken?: string;

  // tenvideo
  vuserid?: string;
  vusession?: string;

  // weishi
  personId?: string;
  iAuthType?: string;
  sSessionKey?: string;
  sUid?: string;
  weseeAppid?: string;
  sThrAppid?: string;
}

export interface UserInfo {
  nickname: string;
  avatar: string;
}
